import { SystemService } from './../../service/system.service';
var utilityService = (function () {
    function utilityService() {
        this.systemS = new SystemService();
    }
    utilityService.prototype.isAPI19 = function () {
        if (this.systemS.isAndroid()) {
            var androidVersion = this.systemS.getAndroidVersion();
            if (androidVersion) {
                if (androidVersion.charAt(0) === '4') {
                    return true;
                }
            }
        }
        return false;
    };
    utilityService.prototype.applyConditionalCss = function () {
        if (this.isAPI19()) {
            // in API 19 app-sidenav takes the full screen height
            // so for mobile screen in api 19 a margin-top 56px is applied
            // so that the content comes below toolbar
            var sidenavs = document.querySelectorAll('.app-sidenav');
            for (var i = 0; i < sidenavs.length; i++) {
                sidenavs[i]['style']['marginTop'] = '56px';
            }
        }
    };
    return utilityService;
}());
export { utilityService };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/services/utility/utility.service.ts.pre-build-optimizer.js